import { X } from "lucide-react";
import { useStore } from "@/context/StoreContext";

export default function MobileMenu() {
  const { menuOpen, setMenuOpen, t, scrollToSection, lang, toggleLang, toast } = useStore();

  const links = [
    { id: "home", key: "nav.home" },
    { id: "products", key: "nav.shop" },
    { id: "story", key: "nav.story" },
    { id: "active", key: "nav.active" },
    { id: "support", key: "nav.support" },
  ];

  return (
    <aside className={`mobile-menu ${menuOpen ? "show" : ""}`} data-testid="mobile-menu" aria-hidden={!menuOpen}>
      <button className="close-btn" data-testid="mobile-menu-close" aria-label="Close menu" onClick={() => setMenuOpen(false)}>
        <X size={18} />
      </button>

      <div className="mobile-menu-links">
        {links.map((l) => (
          <button key={l.id} data-testid={`mobile-menu-${l.id}-link`} onClick={() => scrollToSection(l.id)}>
            {t(l.key)}
          </button>
        ))}
      </div>

      <div className="mobile-menu-lang">
        <button
          className="lang-btn"
          data-testid="mobile-language-toggle-button"
          onClick={() => { toggleLang(); toast(t("toast.language")); }}
          aria-label="Switch language"
        >
          <span className={lang === "kh" ? "on" : "off"}>ខ្មែរ</span>
          <span className="sep">|</span>
          <span className={lang === "en" ? "on" : "off"}>EN</span>
        </button>
      </div>
    </aside>
  );
}
